import { StyleSheet } from 'aphrodite';

export const styles = StyleSheet.create({
  input: {
    width: '100%',
    height: 40,
  },
});
